/**
 * Feature flags for conditional feature enablement.
 * Toggle AUTHORISED_CONTENT_ENABLED to false to bypass all
 * authorised content gates and token injection.
 */
export const AUTHORISED_CONTENT_ENABLED = true as boolean
